const sliderTimelineThumbnail = new Swiper('.timeline-slider__timeline-nav', {
  loop: false,
  slidesPerView: 4,
  spaceBetween: 0,
  watchSlidesProgress: true,
});

const sliderTimelineMain = new Swiper('.timeline-slider__timeline-main', {
  spaceBetween: 12,
  slidesPerView: 1,
  loop: false,
  thumbs: {
    swiper: sliderTimelineThumbnail
  },
  breakpoints: {
    581: {
      slidesPerView: 2,
    },
    981: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});